import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import 'ol/ol.css';
import { Map, View } from 'ol';
import VectorLayer from 'ol/layer/Vector';
import TileLayer from 'ol/layer/Tile';
import LayerImage from 'ol/layer/Image';
import VectorSource from 'ol/source/Vector';
import SourceImagestatic from 'ol/source/ImageStatic';
import XYZ from 'ol/source/XYZ';
import { defaults } from 'ol/control';
import Attribution from 'ol/control/Attribution';
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
import Projection from 'ol/proj/Projection';
// import Point from 'ol/geom/Point'
import { Circle, Point, LineString, GeometryCollection, Polygon } from 'ol/geom';
import Style from 'ol/style/Style';
import StyleIcon from 'ol/style/Icon';
import StyleText from 'ol/style/Text';
import StyleFill from 'ol/style/Fill';
import StyleStroke from 'ol/style/Stroke';
import StyleCircle from 'ol/style/Circle';
import { Circle as CircleStyle } from 'ol/style';
import Feature from 'ol/Feature';
import { GeoJSON } from 'ol/format';
import Overlay from 'ol/Overlay';
import { all } from 'ol/loadingstrategy';
import { Draw, Snap, Modify, Select, DragBox, Translate } from 'ol/interaction';
import { platformModifierKeyOnly, click } from 'ol/events/condition';
import { getWidth, boundingExtent, getCenter, getHeight } from 'ol/extent';
import * as olRender from 'ol/render';
import axios from 'axios';
import { gaoDeToBaidu, bd_decrypt, loadScript, getImg, createBezierCurvePoints, getPointsBetweenLatLong } from '@/utils/utils';
import { mapState, mapGetters, mapMutations } from 'vuex';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import { getPan, getPinchRotate, getdragPan } from '@/view/map/js/common';
import cdata from '@/view/map/hdmconfigv2/common.js';
let _ = require('lodash');
export default {
  name: 'mapv2assembly',
  props: {
    jsonOption: {
      type: Object,
      default: {}
    },
    formatData: {
      type: Object,
      default: {}
    },
    cformUser: {
      type: Object,
      default: {}
    },
    formUserId: {
      type: Number,
      default: 0
    },
    id: {
      type: Number,
      default: 0
    },
    zoom: {
      type: Number,
      default: 5
    },
    minZoom: {
      type: Number,
      default: 0
    },
    maxZoom: {
      type: Number,
      default: 28
    },
    center: {
      type: Array,
      default: [116.3683244, 39.915085]
    },
    extent: {
      type: Array,
      default: [73.502355, 3.397162, 135.09567, 53.563269]
    },
    showgdtilelayer: {
      type: Boolean,
      default: false
    },
    showstaticlayer: {
      type: Boolean,
      default: false
    },
    staticimage: {
      type: String,
      default: ''
    },
    showgeojsonlayer: {
      type: Boolean,
      default: false
    },
    geojson: {
      type: Object,
      default: {}
    },
    drawelement: {
      type: Object,
      default: {}
    },
    showroutelayer: {
      type: Boolean,
      default: false
    },
    adcode: {
      type: String,
      default: '100000'
    },
    streetcode: {
      type: Array,
      default: []
    },
    pointlist: {
      type: Array,
      default: []
    },
    scale: {
      type: Boolean,
      default: false
    },
    rotate: {
      type: Boolean,
      default: false
    },
    translate: {
      type: Boolean,
      default: false
    },
    mapstyle: {
      type: Object,
      default: {}
    },
    culturallist: {
      type: Array,
      default: []
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    location: {
      type: Object,
      default: {}
    },
    rotation: {
      type: Number,
      default: 0
    },
    geoJsonData: {
      type: Object,
      default: {}
    }
  },
  components: {},
  meta: {
    title: 'openlayermap组件'
  },
  data() {
    return {
      currentArea: {},
      mapcontainer: '',
      map: '',
      iconSource: '',
      iconLayer: [],
      style: {},
      cfeature: null,
      timer: null,
      defaultZoom: 0,
      moveendflag: true,
      drawflag: false,
      drawSource: '',
      drawLayer: [],
      drawsketch: '',
      drawinter: '',
      snapinter: '',
      modifyinter: '',
      helpTooltip: '',
      helpTooltipElement: '',
      deleteflag: false,
      selectinter: '',
      selectedFeatures: [],
      dragboxinter: '',
      drawstyle: {
        color: 'rgba(0,0,0,0.5)',
        width: 1,
        lineDash: [2, 2]
      },
      drawtextflag: false,
      drawtextsingleflag: false,
      translateinter: '',
      isnotclick: false,
      currentTextstyle: {
        align: 0,
        // 排列方式 0纵向 1横向
        fontSize: 12,
        color1: 'rgba(0, 0, 0, 1)',
        color2: 'rgba(123, 33, 33, 1)'
      },
      defaulticon: 'https://p.ananas.chaoxing.com/star3/origin/6e34ee5cc29e45f92fc9347bf35febfb.png',
      overlay: 'undefined',
      findex: 0,
      CircleRadius: 5,
      lightIcon: [require('@/assets/map/138053/color1.gif'), require('@/assets/map/138053/color2.gif'), require('@/assets/map/138053/color3.gif'), require('@/assets/map/26091/xk.png'), require('@/assets/map/26091/xxhx.png')],
      //   customMapHubeihoverImg:[
      //     { fid: 26091, code: 420300, image:  require('@/assets/map/26091/shiyanshi.png') },
      // { fid: 26091, code: 429021, image:  require('@/assets/map/26091/shennongjia.png') },
      // { fid: 26091, code: 420600, image: require('@/assets/map/26091/xiangyang.png') },
      // { fid: 26091, code: 421300, image:  require('@/assets/map/26091/suzhoushi.png') },
      //   ],
      hoverImg: '',
      hoverImgList: [],
      routeSource: '',
      routeLayer: [],
      locationSource: '',
      locationLayer: [],
      locationicon: 'https://p.ananas.chaoxing.com/star3/origin/8077173b8e82056110d8b5ea170d68c4.png',
      animating: false,
      movedefaulticon: 'https://p.ananas.chaoxing.com/star3/origin/da0e3c42e5eca5562aeadbbe88bf1def.png',
      moveicon: 'https://p.ananas.chaoxing.com/star3/origin/da0e3c42e5eca5562aeadbbe88bf1def.png',
      nowDate: '',
      moveprogress: '',
      geoMarker: '',
      jsonSource: '',
      routeData: [],
      selectIndex: '',
      selectCoords: [],
      selectcurveCoords: [],
      routeStyle: '',
      curvetools: null,
      modifySource: '',
      curverouteCoords: [],
      iseditpoint: false,
      selectArr: [],
      pointIcon: '',
      polygonfeature: '',
      linefeature: '',
      viewratio: 0,
      nmaxlen: 0,
      drift: 0,
      increase: 0,
      ih: 26,
      transdiffx: 0,
      transdiffy: 0,
      boxId: 0,
      areaList: [],
      starIcon: '',
      needAllFeture: [],
      dialogVisible: true,
      vectorSource: null
    };
  },
  created() {
    loadScript(`${process.env.NODE_ENV === 'development' ? '/fileapi' : location.origin}/frontendTest1/openlayers/js/gifler.min.js`);
  },
  computed: {
    ...mapGetters(['mapv2info']),
    mapv2infoViewchange() {
      const {
        zoom,
        minZoom,
        maxZoom,
        center,
        rotation
      } = this.mapv2info.view;
      return {
        zoom,
        minZoom,
        maxZoom,
        center,
        rotation
      };
    }
  },
  mounted() {
    console.log('geoJsonData');
    console.log(this.geoJsonData);
    // formUserId: 1516351940 为橙色     formUserId: 1516336824 为蓝色  formUserId:  1514653091 展示
    ////console.log('this.formUserId')
    ////console.log(this.formUserId)
    console.log('this.jsonOption', this.jsonOption);
    this.initMap();
    this.style = this.id === 0 ? this.mapv2info.style : this.mapstyle;
    ////////////////console.log(`this.style`, this.style);
    if (this.style.routemoveicon !== undefined && this.style.routemoveicon.length > 0) this.moveicon = this.style.routemoveicon[0].fileUrl;
    this.hoverImgList = this.formUserId == 1516351940 ? cdata.maphoverimagesHubei : this.formUserId == 1516336824 ? cdata.maphoverimagesHubeiJiaohu : cdata.maphoverimagesHubeiJiaohu;
    ////////////////console.log('this.hoverImgList',this.hoverImgList)

    if (this.$route.query.edit) this.iseditpoint = true;
    // if(this.formUserId==1514653091){
    //   this.iseditpoint = true
    // }
  },
  watch: {
    pointlist: {
      handler(val) {
        console.log(`pointlist`);
        console.log(val);
        this.createPoint(val);
        // 暂时注释1105
        this.drawAreaList();
        if (this.iseditpoint) this.addDrawInteractions1();
      },
      deep: true
    },
    'showgdtilelayer': {
      handler(val) {
        ////console.log(`showgdtilelayer`, val);
        this.map.getLayers().getArray().forEach(item => {
          if (item.className_ === 'tile') item.setVisible(val);
        });
      },
      deep: true
    },
    'staticimage': {
      handler(val) {
        ////console.log(`staticimage`, val);
        if (val) {
          this.map.getLayers().getArray().forEach(item => {
            if (item.className_ === 'static') {
              item.setVisible(true);
              const imageExtent = transformExtent(this.extent, 'EPSG:4326', 'EPSG:3857');
              const imageProjection = new Projection({
                code: 'xkcd-image',
                units: 'pixels',
                extent: imageExtent
              });
              item.setSource(new SourceImagestatic({
                url: val,
                projection: imageProjection,
                imageExtent: imageExtent
              }));
            }
            if (item.className_ === 'json') item.setOpacity(0);
          });
        }
      },
      deep: true
    },
    culturallist: {
      handler(val) {
        ////console.log(`culturallist`);
        ////console.log(val);
        this.createculturalPoint(val);
      },
      deep: true
    },
    showroutelayer: {
      handler(val) {
        ////console.log(`showgdtilelayer`, val);
        this.map.getLayers().getArray().forEach(item => {
          if (item.className_ === 'route') item.setVisible(val);
        });
      },
      deep: true
    },
    location: {
      handler(val) {
        this.loadLocation(val);
      },
      deep: true
    },
    'mapv2info.style.pointpic': {
      handler(val) {
        ////console.log(`mapv2info.style.pointpic`, val);
        this.iconSource.clear();
        this.createPoint(this.pointlist);
        if (this.mapv2info.form.cTemplateScore === 1) this.createculturalPoint(this.culturallist);
      },
      deep: true
    },
    'mapv2info.style.pointicon': {
      handler(val) {
        ////console.log(`mapv2info.style.pointicon`, val);
        this.iconSource.clear();
        this.createPoint(this.pointlist);
      },
      deep: true
    },
    'mapv2info.style.pointtext': {
      handler(val) {
        ////console.log(`mapv2info.style.pointtext`, val);
        this.iconSource.clear();
        this.createPoint(this.pointlist);
      },
      deep: true
    },
    'mapv2info.style.pointStyleIndex'(val) {
      ////console.log(`mapv2info.style.pointStyleIndex`, val);
      this.iconSource.clear();
      this.createPoint(this.pointlist);
    },
    'mapv2info.style.showroute'(val) {
      ////console.log(`mapv2info.style.showroute`, val);
      this.map.getLayers().getArray().forEach(item => {
        if (item.className_ === 'route') item.setVisible(val === 1 ? true : false);
      });
      this.createRoute(this.mapv2info.routeSources);
    },
    'mapv2info.style.routemoveicon': {
      handler(val) {
        ////console.log(`mapv2info.style.routemoveicon`, val);
        this.moveicon = val.length > 0 ? val[0].fileUrl : this.movedefaulticon;
      },
      deep: true
    },
    mapv2infoViewchange() {
      this.updateMap();
    },
    'mapv2info.view.scale'(val) {
      ////console.log(`mapv2info.view.scale`, val);
      val ? getPan(this.map) : getPan(this.map, true);
    },
    'mapv2info.view.rotate'(val) {
      ////console.log(`mapv2info.view.rotate`, val);
      val ? getPinchRotate(this.map) : getPinchRotate(this.map, true);
    },
    'mapv2info.view.translate'(val) {
      ////console.log(`mapv2info.view.translate`, val);
      val ? getdragPan(this.map) : getdragPan(this.map, true);
    },
    'mapv2info.drawlayer.toolsIndex'(val) {
      // 操作类型 0绘制文字 1绘制线 2删除 3框选 4平移
      ////console.log(`mapv2info.drawlayer.toolsIndex`, val);
      if (val === '') return;
      this.changeToolHandle(val);
    },
    'mapv2info.drawlayer.linestyle'(val) {
      ////console.log('mapv2info.drawlayer.linestyle')
      ////console.log(val)
      if (val) {
        this.drawstyle = val;
        this.drawSource.getFeatures().forEach(feature => {
          if (feature.getGeometry() && feature.getGeometry().getType() === 'LineString') feature.setStyle(new Style({
            stroke: new StyleStroke(val)
          }));
          if (feature.getGeometry() && feature.getGeometry().getType() === 'Circle') feature.setStyle(new Style({
            fill: new StyleFill({
              color: val.color
            }),
            stroke: new StyleStroke({
              color: val.color,
              width: this.CircleRadius
            })
          }));
        });
      }
    },
    'mapv2info.drawlayer.currentList'(val) {
      ////console.log('mapv2info.drawlayer.currentList')
      this.createText(val, 'currentList');
    },
    'mapv2info.drawlayer.drawtextblocksum'(val) {
      ////console.log('mapv2info.drawlayer.drawtextblocksum', val)
      this.createText(val, 'drawtextblocksum');
    },
    'mapv2info.drawlayer.showtranfer'(val) {
      ////console.log('mapv2info.drawlayer.showtranfer', val)
      if (!val && this.mapv2info.drawlayer.dtext) this.showtexthelp();
    },
    'mapv2info.drawlayer.currentTextstyle': {
      handler(val) {
        ////console.log('mapv2info.drawlayer.currentTextstyle')
        ////console.log(val)
        if (val) {
          this.currentTextstyle = val;
          this.createText(this.mapv2info.drawlayer.currentList, 'currentList');
        }
      },
      deep: true
    },
    'mapv2info.routeSources': {
      handler(val) {
        if (!this.showroutelayer) return;
        this.createRoute(val);
      },
      deep: true
    }
  },
  methods: {
    onlyAreaList(val) {
      const filteredArray = val.filter(item => {
        // 判断 data 是否为空，这里定义了空的几种情况：null, undefined, 空字符串, 空数组  
        const isEmpty = item.data === null || item.data === undefined || item.data === "" || Array.isArray(item.data) && item.data.length === 0;

        // 返回非空的对象  
        return !isEmpty;
      });
      return filteredArray;
    },
    addDrawInteractions1() {
      this.addselectInteraction();
      this.adddragboxInteraction();
    },
    ...mapMutations(['SET_MAPDRAWLAYERITEM', 'SET_MAPROUTECURVE']),
    quitPointHandle() {
      // this.dialogVisible = false
    },
    confirmPointHandle() {
      // this.dialogVisible = false
      this.jsonOption.drawlayer.drawarea = this.onlyAreaList(this.areaList);
      console.log('this.jsonOption.drawlayer');
      console.log(this.jsonOption);
      let richtext = `<p element-id=\"init\" style="display: none;">${JSON.stringify(this.jsonOption)}</p>`;
      let dataList = [];
      dataList.push({
        'alias': 'onlyid',
        'compt': 'autonumber',
        'values': [{
          'val': this.formatData.onlyid
        }]
      });
      dataList.push({
        'alias': 'title',
        'compt': 'editinput',
        'values': [{
          'val': this.formatData.title
        }]
      });
      dataList.push({
        'alias': 'jsontxt',
        'compt': 'richtext',
        'values': [{
          'val': richtext
        }]
      });
      // ////console.log(`dataList`, dataList)
      // return
      this.$api.editForm(this.$route.query.fid, this.$route.query.formUserId, encodeURI(JSON.stringify(dataList)), this.cformUser.formId).then(res => {
        ElMessage({
          message: '保存成功',
          type: 'success'
        });
      });
    },
    /**
     * 初始化地图
     */
    initMap() {
      ////////////////console.log('初始化地图', this.zoom);
      this.defaultZoom = Math.round(this.zoom);
      const defaultlayer = this.getTileLayer();
      const staticImageLayer = this.getstaticImageLayer();
      const jsonlayer = this.getjsonlayer();
      const hoverLayer = this.gethoverLayer();

      // 地图地点图层
      this.iconSource = new VectorSource();
      this.iconLayer = new VectorLayer({
        source: this.iconSource,
        className: 'icon',
        zIndex: 6
      });

      // 地图路线图层
      this.routeSource = new VectorSource();
      this.routeLayer = new VectorLayer({
        source: this.routeSource,
        className: 'route',
        zIndex: 5
      });
      // 绘制图层
      this.drawLayer = this.getDrawLayer();
      this.drawSource.on('change', evt => {
        this.drawSourceChange(evt);
      });

      // 地图地点图层
      this.locationSource = new VectorSource();
      this.locationLayer = new VectorLayer({
        source: this.locationSource,
        className: 'location',
        zIndex: 8
      });
      this.mapcontainer = this.$refs[`map${this.id}`];
      ////////////////console.log(`this.rotation`, this.rotation)
      this.map = new Map({
        layers: [defaultlayer, staticImageLayer, jsonlayer, hoverLayer, this.routeLayer, this.iconLayer, this.drawLayer, this.locationLayer],
        target: this.mapcontainer,
        view: new View({
          center: transform(this.center, 'EPSG:4326', 'EPSG:3857'),
          minZoom: this.minZoom,
          maxZoom: this.maxZoom,
          zoom: this.zoom,
          rotation: this.rotation
        }),
        controls: defaults({
          attribution: false
        })
      });
      this.scale ? getPan(this.map) : getPan(this.map, true);
      this.rotate ? getPinchRotate(this.map) : getPinchRotate(this.map, true);
      this.translate ? getdragPan(this.map) : getdragPan(this.map, true);
      this.map.on('singleclick', this.singleclick);
      this.map.on('click', this.markerclick);
      this.map.on('pointermove', this.markermove);
      this.map.getLayers().getArray().forEach(item => {
        if (item.className_ === 'tile') item.setVisible(this.showgdtilelayer);
        if (item.className_ === 'static') item.setVisible(this.showstaticlayer);
        if (item.className_ === 'json') {
          item.setVisible(this.showgeojsonlayer);
          // 这里控制位置标定线的显示与隐藏
          if (this.staticimage) item.setOpacity(0);
        }
        if (item.className_ === 'hoverimg') item.setVisible(false);
        if (item.className_ === 'route') item.setVisible(this.showroutelayer);
      });
      this.map.on('moveend', this.markermoveend);
      this.drawfitHandle();
      this.initMapLine();
    },
    initMapLine() {
      this.geoJsonData.features.forEach(feature => {
        if (feature.geometry.type === 'LineString') {
          const lineFeature = new Feature(new LineString(feature.geometry.coordinates));
          this.drawSource.addFeature(lineFeature);

          // 提取线段端点并创建点特征  
          const coordinates = lineFeature.getGeometry().getCoordinates();
          const startPoint = new Feature(new Point(coordinates[0]));
          const endPoint = new Feature(new Point(coordinates[coordinates.length - 1]));

          // 应用图标样式到点特征  
          const iconStyle = new Style({
            image: new StyleIcon({
              src: require('@/assets/map/138053/circle.png'),
              anchor: [0.5, 1],
              // 锚点设置，根据图标调整  
              anchorXUnits: 'fraction',
              anchorYUnits: 'fraction'
            })
          });
          startPoint.setStyle(iconStyle);
          endPoint.setStyle(iconStyle);
          this.drawSource.addFeature(startPoint);
          this.drawSource.addFeature(endPoint);
        }
      });
    },
    /**
     * 非1920*1080分辨率且绘制图层有数据时 处理显示范围及位置
     */
    drawfitHandle() {
      //console.log('1111')
      if (document.body.clientWidth !== 1920 && this.drawSource !== '') {
        let widthflag = document.body.clientWidth <= 1440;
        let listpos = this.mapstyle.listpos;
        let mapPadding = [30, 30, 30, 30];
        let type = listpos.ptype.split('-');
        switch (type[0]) {
          case 'left':
            mapPadding[3] = widthflag <= 1440 ? 430 : 530;
            break;
          case 'right':
            mapPadding[1] = widthflag <= 1440 ? 430 : 530;
            break;
        }
        this.$nextTick(() => {
          this.map.getView().fit(this.drawSource.getExtent(), {
            size: this.map.getSize(),
            padding: mapPadding
          });
        });
      }
    },
    /**
     * 加载高德地图瓦片作为底图
     */
    getTileLayer() {
      return new TileLayer({
        source: new XYZ({
          url: 'http://webrd03.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}'
        }),
        className: 'tile',
        zIndex: 1
      });
    },
    /**
     * 加载静态图片
     */
    getstaticImageLayer() {
      ////////////////console.log(`this.staticimage`, this.staticimage);
      // 假设你的图层边界在4326下是 [minx, miny, maxx, maxy]
      const layerExtentIn4326 = this.extent;
      // 转换边界的对角点到3857坐标系
      const bottomLeftIn3857 = fromLonLat([layerExtentIn4326[0], layerExtentIn4326[1]]);
      const topRightIn3857 = fromLonLat([layerExtentIn4326[2], layerExtentIn4326[3]]);
      // 创建在3857坐标系下的边界（注意：extent 是 [minx, miny, maxx, maxy]）
      const layerExtentIn3857 = [bottomLeftIn3857[0], bottomLeftIn3857[1], topRightIn3857[0], topRightIn3857[1]];
      return new LayerImage({
        source: new SourceImagestatic({
          url: this.staticimage,
          projection: 'EPSG:3857',
          imageExtent: layerExtentIn3857
        }),
        opacity: 1,
        className: 'static',
        zIndex: 2
      });
    },
    /**
     * 加载GeoJson
     */
    getjsonlayer() {
      if (this.adcode === 'region') {
        // 自定义json数据
        this.jsonSource = new VectorSource({
          features: new GeoJSON().readFeatures(this.geojson)
        });
      } else {
        // 乡镇街道json判断
        if (this.streetcode.length > 0) {
          this.jsonSource = new VectorSource({
            features: new GeoJSON().readFeatures(this.geojson, {
              dataProjection: 'EPSG:4326',
              featureProjection: 'EPSG:3857'
            })
          });
        } else {
          let apiurl = `${process.env.NODE_ENV === 'development' ? '/fileapi' : location.origin}/frontendTest1/openlayers/data/`;
          if (this.adcode.includes(',')) {
            this.jsonSource = new VectorSource();
            let adcodes = _.cloneDeep(this.adcode).split(',');
            let adcodesArr = [];
            adcodes.forEach(elem => {
              adcodesArr.push(`${apiurl}${elem}${this.mapv2info.form.ishaschild === '是' ? '_full' : ''}.json`);
            });
            let that = this;
            adcodesArr.forEach(elem => {
              axios.get(elem).then(res => {
                let jsondata = new GeoJSON().readFeatures(res.data, {
                  dataProjection: 'EPSG:4326',
                  featureProjection: 'EPSG:3857'
                });
                that.mapv2info.form.ishaschild === '是' ? that.jsonSource.addFeatures(jsondata) : that.jsonSource.addFeature(jsondata[0]);
              });
            });
          } else {
            // 省市区县json
            this.jsonSource = new VectorSource({
              format: new GeoJSON(),
              url: `${apiurl}${this.adcode.includes('_full') ? this.adcode.replace('_full', '') : this.adcode}${this.mapv2info.form.ishaschild === '是' ? '_full' : ''}.json`
            });
          }
        }
      }
      return new VectorLayer({
        source: this.jsonSource,
        opacity: 1,
        style: this.jsonstyleFunction(),
        className: 'json',
        zIndex: 3
      });
    },
    jsonstyleFunction() {
      return [new Style({
        stroke: new StyleStroke({
          color: 'rgba(5, 146, 232, 1)',
          width: 1
        }),
        fill: new StyleFill({
          color: 'rgba(5, 146, 232, 0.2)'
        })
      })];
    },
    gethoverLayer() {
      return new LayerImage({
        source: new SourceImagestatic({
          url: this.hoverImg,
          projection: 'EPSG:3857',
          imageExtent: []
        }),
        opacity: 1,
        className: 'hoverimg',
        zIndex: 4
      });
    },
    /**
     * 绘制图层
     */
    getDrawLayer() {
      this.drawSource = new VectorSource();
      // 非遗地图移动端不显示绘制图层
      if (Object.keys(this.drawelement).length > 0 && this.drawelement.drawJson) {
        let data = this.drawelement;
        const featureJson = new GeoJSON().readFeatures(data.drawJson);
        featureJson.forEach((feature, index) => {
          if (feature.get('name')) {
            let textstyle = feature.get('style');
            let name = feature.get('name');
            if (textstyle.align === 0) {
              name = name.replace(/\uff08/g, '\ufe35');
              name = name.replace(/\uff09/g, '\ufe36');
              name = name.split('').join('\n');
            } else {
              name = name.replace(/\ufe35/g, '\uff08');
              name = name.replace(/\ufe36/g, '\uff09');
            }
            feature.setStyle(new Style({
              text: new StyleText({
                text: name,
                font: `${textstyle.fontSize}px FZShengShiKaiShuS-DB-GB`,
                textBaseline: 'top',
                textAlign: 'left',
                fill: new StyleFill({
                  color: textstyle.color
                })
              })
            }));
          }
          if (feature.getGeometry() && feature.getGeometry().getType() === 'LineString') {
            let linestyle = Object.keys(data.linestyle).length > 0 ? data.linestyle : this.drawstyle;
            feature.setStyle(new Style({
              stroke: new StyleStroke(linestyle)
            }));
          }
          if (feature.getGeometry() && feature.getGeometry().getType() === 'GeometryCollection' && feature.get('type') === 'circle') {
            let linestyle = Object.keys(data.linestyle).length > 0 ? data.linestyle : this.drawstyle;
            feature = new Feature({
              geometry: new Circle(feature.get('coordinate'), this.CircleRadius),
              type: 'circle',
              coordinate: feature.get('coordinate')
            });
            feature.setStyle(new Style({
              fill: new StyleFill({
                color: linestyle.color
              }),
              stroke: new StyleStroke({
                color: linestyle.color,
                width: this.CircleRadius
              })
            }));
          }
          this.drawSource.addFeature(feature);
        });
        if (Object.keys(data.linestyle).length > 0) {
          this.drawstyle = data.linestyle;
        }
      }
      return new VectorLayer({
        source: this.drawSource,
        className: 'draw',
        style: new Style({
          stroke: new StyleStroke(this.drawstyle)
        }),
        zIndex: 7
      });
    },
    drawSourceChange(evt) {
      ////////////////console.log('evt',evt)
      let that = this;
      evt.target.getFeatures().forEach(feature => {
        if (feature.get('dindex') !== undefined) {
          let arrCoordinates = feature.getGeometry().getCoordinates();
          let defaultValue = [...arrCoordinates];
          let coordinates = [];
          // 两点 判断起始点 确定方向 绘制直角直线
          if (arrCoordinates.length === 2) {
            coordinates.push(defaultValue[0]);
            coordinates.push(that.getcurrentCoordinates(defaultValue[0], defaultValue[1]));
          }
          if (arrCoordinates.length > 2) {
            function setCoordinatesArr(i) {
              if (i === 0) {
                coordinates.push(defaultValue[i]);
                setCoordinatesArr(i + 1);
              } else if (i > defaultValue.length - 1) {
                return;
              } else {
                let nextC = that.getcurrentCoordinates(coordinates[i - 1], defaultValue[i]);
                coordinates.push(nextC);
                setCoordinatesArr(i + 1);
              }
            }
            setCoordinatesArr(0);
          }
          let features = [];
          // 创建直角线段的几何对象
          const geometry = new LineString(coordinates);

          // 创建具有直角线段几何对象的特性
          const linefeature = new Feature({
            geometry: geometry,
            findex: feature.get('dindex')
          });

          // 设置线的样式
          linefeature.setStyle(new Style({
            stroke: new StyleStroke(this.drawstyle)
          }));
          let lineStart = coordinates[0];
          let lineEnd = coordinates[coordinates.length - 1];
          let startCircleGeom = new Circle(lineStart, this.CircleRadius);
          let endCircleGeom = new Circle(lineEnd, this.CircleRadius);
          const circleitemStyle = new Style({
            fill: new StyleFill({
              color: this.drawstyle.color
            }),
            stroke: new StyleStroke({
              color: this.drawstyle.color,
              width: this.CircleRadius
            })
          });
          let startfeature = new Feature({
            geometry: startCircleGeom,
            type: 'circle',
            coordinate: lineStart
          });
          startfeature.setStyle(circleitemStyle);
          let endfeature = new Feature({
            geometry: endCircleGeom,
            type: 'circle',
            coordinate: lineEnd
          });
          endfeature.setStyle(circleitemStyle);
          features = [linefeature, startfeature, endfeature];
          this.drawSource.removeFeature(feature);
          this.drawSource.addFeatures(features);
        }
      });
    },
    /**
     * 更新地图
     */
    updateMap() {
      this.$nextTick(() => {
        ////////////////console.log('更新地图');
        this.map.getView().setCenter(transform(this.center, 'EPSG:4326', 'EPSG:3857'));
        this.map.getView().setMinZoom(this.minZoom);
        this.map.getView().setMaxZoom(this.maxZoom);
        this.map.getView().setZoom(this.zoom);

        // 东胜地图添加旋转
        if (this.$route.query.fid === '166970') {
          // this.map.render()
          this.map.getView().on('change:rotation', evt => {
            ////////////////console.log(evt);
            this.map.updateSize();
          });
          this.map.getView().setRotation(this.rotation);
        }
      });
    },
    /**
     * 单击地图操作
     */
    singleclick(val) {
      // let feature = this.map.forEachFeatureAtPixel(val.pixel,
      //   function (feature) { return feature }
      // )
      // if (feature && !feature.get('xy')) {
      //   //console.log('this.selectinter.getFeatures().getArray()')
      //   //console.log(feature)
      //  return 
      // }
      // if(this.selectinter.getFeatures().getArray()[0].get('id')==undefined){
      //   return
      // }
      ////////////////console.log(val)
      //console.log('singleclick',val)
      // 高德坐标
      let coordinateArr = transform(val.coordinate, 'EPSG:3857', 'EPSG:4326');
      // 绘制线段 禁止单击
      if (this.drawflag) return;
      // 绘制文字操作
      if (this.drawtextflag) {
        this.drawtextsingleflag = true;
        this.helpTooltipElement.innerHTML === '';
        this.helpTooltipElement.classList.add('hidden');
        if (this.drawtextsingleflag) {
          this.SET_MAPDRAWLAYERITEM({
            showtranfer: true
          });
          this.SET_MAPDRAWLAYERITEM({
            currentCoordinate: coordinateArr
          });
          return;
        }
      }
      let bdpoint = gaoDeToBaidu(coordinateArr[0].toFixed(6), coordinateArr[1].toFixed(6));
      this.$emit('singleclick', `${bdpoint.lng.toFixed(6)}, ${bdpoint.lat.toFixed(6)}`);
      // this.confirmPointHandle()
    },
    /**
     * 创建地图点位
    * @param {Array} val 点位数据
     */
    createPoint(val, city, citygroup, dxqinfo) {
      //console.log('createPoint',val)
      // if(city||citygroup){
      //   this.iconSource.clear()
      // }

      // //console.log('this.selectedFeatures',this.selectedFeatures)
      //console.log('val',val)
      this.iconSource.clear();
      if (val.length === 0) return;
      let that = this;
      val.forEach(elem => {
        let item = elem.itemformdata;
        let c = item.map_coordinates.split(',');
        let gd = bd_decrypt(Number(c[0]), Number(c[1]));
        let x = Number(gd.lng);
        let y = Number(gd.lat);

        // if(item.place_name=='荆楚理工学院'){
        //   ////////////////console.log('item',item)
        //   ////////////////console.log('elem',elem)
        // }
        // this.iconSource.getFeatures().forEach(e=>{
        //   ////console.log('item.place_name')
        //   ////console.log(item.place_name)

        //   // if(e.getStyle()[1].text_.text_==item.place_name){
        //   //   ////console.log(e.getStyle()[1].text_.text_==item.place_name)
        //   //   e.getStyle()[1].text_.city=item['70']?item['70']:''
        //   //   e.getStyle()[1].text_.dxq=item['69']?item['69']:''
        //   //   alert(123)
        //   // }
        // })
        let obj = {
          name: item.place_name,
          image: item[4].length > 0 ? getImg(item[4][0]) : this.defaulticon,
          icon: item[75] != '' ? item[75][0].fileUrl : '',
          showPlaceName: item.showplace_name,
          showPlaceIcon: item.show4,
          showZhxyjsx: item['71'] ? item['71'] : '',
          showXxhx: item['72'] ? item['72'] : '',
          showSfxk: item['73'] ? item['73'] : '',
          city: item['70'] ? item['70'] : '',
          dxq: item['69'] ? item['69'] : '',
          mapCoordinates: item['map_coordinates'] ? item['map_coordinates'] : '',
          showHighlight: city ? item['70'] == city.values_.name ? true : false : dxqinfo ? dxqinfo == item['69'] ? true : false : false
        };
        let pointfeature = new Feature({
          geometry: new Point(fromLonLat([x, y])),
          id: elem.id,
          name: obj.name,
          image: obj.image,
          icon: '',
          xy: [x, y],
          score: 0
        });
        if (item[4].length > 0 && item[4][0].suffix === 'gif') {
          obj.gif = getImg(item[4][0]);
          this.timer = setInterval(() => {
            if (gifler && that.style.pointStyleIndex) {
              const gifUrl = getImg(item[4][0]);
              const gif = gifler(gifUrl);
              gif.frames(document.createElement('canvas'), function (ctx, frame) {
                if (!pointfeature.getStyle()) {
                  pointfeature.setStyle(that.getStyle(obj, that.style.pointStyleIndex, ctx, frame));
                }
                ctx.clearRect(0, 0, frame.width, frame.height);
                ctx.drawImage(frame.buffer, frame.x, frame.y);
                that.map.render();
              }, true);
              clearInterval(that.timer);
              that.timer = null;
            }
          }, 100);
        } else {
          ////console.log(`obj`, obj);
          ////console.log(`this.getStyle(obj, 9)`,this.getStyle(obj, 9));
          pointfeature.setStyle(this.getStyle(obj, 9));
          // pointfeature.setStyle([this.getStyle(obj, this.style.pointStyleIndex),this.getStyle(obj, this.style.pointStyleIndex)])
        }
        this.iconSource.addFeature(pointfeature);
      });
      this.needAllFeture = this.iconSource.getFeatures();
      val.forEach(elem => {
        let item = elem.itemformdata;
        this.needAllFeture.forEach(e => {
          if (e.getStyle()[1].text_.text_ == item.place_name) {
            // ////console.log(e.getStyle()[1].text_.text_==item.place_name)
            e.getStyle()[1].text_.city = item['70'] ? item['70'] : '';
            e.getStyle()[1].text_.dxq = item['69'] ? item['69'] : '';
          }
        });
      });

      // ////console.log('this.needAllFeture',this.needAllFeture)
    },
    /**
     * 设置相应样式
     */
    getStyle(item, sIndex, ctx, frame) {
      ////////////////console.log('length',item.name.length)
      let Styles = [];
      let stext = this.style.pointtext;
      let spic = this.style.pointpic;
      let sicon = this.style.pointicon;

      // 绘制圆角矩形
      let textsize = parseInt(stext.fontSize);
      let canvas = document.createElement('canvas');
      let canvas1 = document.createElement('canvas');
      let canvas2 = document.createElement('canvas');
      let context = canvas.getContext('2d');
      let namelen = item.name.length + 1;
      canvas.width = namelen * textsize;
      canvas.height = textsize + 6;
      canvas1.width = namelen * textsize;
      canvas1.height = textsize + 6;
      canvas2.width = namelen * textsize;
      canvas2.height = textsize + 6;
      let x = 0;
      let y = 0;
      let w = canvas.width;
      let h = canvas.height;
      let w1 = canvas1.width;
      let h1 = canvas1.height;
      let w2 = canvas2.width;
      let h2 = canvas2.height;
      let r = Math.ceil((textsize + 6) / 2);
      // 缩放
      context.scale(1, 1);
      context.fillStyle = stext.fill;
      ////////////////console.log('stext.fill',stext.fill)
      ////////////////console.log(context)
      // 绘制圆角矩形
      context.beginPath();
      context.moveTo(x + r, y);
      context.arcTo(x + w, y, x + w, y + h, r);
      context.arcTo(x + w, y + h, x, y + h, r);
      context.arcTo(x, y + h, x, y, r);
      context.arcTo(x, y, x + w, y, r);
      // 设置阴影
      // context.shadowColor = 'rgba(0, 0, 0, 0.2)' // 颜色
      // context.shadowBlur = 5 // 模糊尺寸
      // context.shadowOffsetX = 2 // 阴影Y轴偏移
      // context.shadowOffsetY = 2 // 阴影X轴偏移
      // ----
      context.closePath();
      // 填充
      context.fill();
      let image = '';
      if (ctx) {
        image = new Style({
          image: new StyleIcon({
            img: ctx.canvas,
            opacity: 1,
            imgSize: [frame.width, frame.height],
            anchor: spic.anchor,
            scale: spic.scale,
            rotateWithView: true
          })
        });
      } else {
        image = new Style({
          image: new StyleIcon({
            src: item.image,
            anchor: spic.anchor,
            scale: spic.scale,
            rotateWithView: true
          })
        });
      }
      // 增加星星

      let icon = item.icon !== '' ? new Style({
        image: new StyleIcon({
          src: item.icon,
          // anchor: [-2.5,0.5],
          anchor: [-(1 + item.name.length - 3), 0.5],
          scale: 0.5,
          rotateWithView: true
        })
      }) : '';

      // ////console.log('12345')
      // ////console.log((item.name.length-6)*((50/6)))
      // ////console.log( Math.floor(-50-((50/6)*(item.name.length-6))) )
      let text = new Style({
        image: new StyleIcon({
          img: canvas,
          imgSize: [w, h],
          rotateWithView: true
        }),
        text: new StyleText({
          text: item.name,
          font: `${stext.fontSize} sans-serif`,
          offsetY: 1,
          // offsetX: Math.floor(-60-((50/6)*(item.name.length-6))),
          offsetX: -35,
          textAlign: item.name.length > 6 ? 'left' : 'left',
          fill: item.showHighlight ? new StyleFill({
            color: '#ffffff'
          }) : new StyleFill({
            color: stext.color
          }),
          stroke: item.showHighlight ? new StyleStroke({
            color: '#045578',
            width: 2
          }) : stext.stroke !== '' ? new StyleStroke({
            color: stext.stroke,
            width: 3
          }) : '',
          // 这是高亮效果
          // fill: new StyleFill({ color: '#ffffff' }),
          // stroke: new StyleStroke({ color: '#045578', width: 2 }),
          rotateWithView: true
        })
      });
      ////////////////console.log('canvas1',canvas1)
      ////////////////console.log('w1',w1)
      ////////////////console.log('h1',h1)
      let text1 = new Style({
        image: new StyleIcon({
          img: canvas1,
          imgSize: [w1, h1],
          rotateWithView: true
        }),
        text: new StyleText({
          textAlign: 'center',
          text: "学校画像",
          font: `${stext.fontSize} sans-serif`,
          offsetY: 0.5,
          offsetX: 80,
          fill: new StyleFill({
            color: "#56BBFB"
          }),
          stroke: stext.stroke !== '' ? new StyleStroke({
            color: "#56BBFB",
            width: 4
          }) : '',
          rotateWithView: true
        })
      });
      let text2 = new Style({
        image: new StyleIcon({
          img: canvas2,
          imgSize: [w2, h2],
          rotateWithView: true
        }),
        text: new StyleText({
          textAlign: 'center',
          text: "巡课",
          font: `${stext.fontSize} sans-serif`,
          offsetY: 0.5,
          offsetX: 120,
          fill: new StyleFill({
            color: stext.color
          }),
          stroke: stext.stroke !== '' ? new StyleStroke({
            color: stext.stroke,
            width: 1
          }) : '',
          rotateWithView: true
        })
      });
      // -3.1
      let addValue1 = -2.1;
      let addValue2 = -2.4;
      if (item['showZhxyjsx'] == '是') {
        addValue1 = -3.1;
      }
      if (item['showZhxyjsx'] == '否') {
        addValue1 = -2.1;
      }
      if (item['showZhxyjsx'] == '是' && item['showSfxk'] == '是') {
        addValue2 = -2.4;
      }
      if (item['showZhxyjsx'] == '是' && item['showSfxk'] == '否') {
        addValue2 = -1.7;
      }
      if (item['showZhxyjsx'] == '否' && item['showSfxk'] == '否') {
        addValue2 = -1.1;
      }
      if (item['showZhxyjsx'] == '否' && item['showSfxk'] == '是') {
        addValue2 = -1.7;
      }
      let icon1 = item.icon !== '' ? new Style({
        image: new StyleIcon({
          src: this.lightIcon[3],
          anchor: [addValue1, 0.5],
          scale: 1,
          rotateWithView: true
        })
      }) : '';
      let icon2 = item.icon !== '' ? new Style({
        image: new StyleIcon({
          src: this.lightIcon[4],
          anchor: [addValue2, 0.5],
          scale: 1,
          rotateWithView: true
        })
      }) : '';
      if (sIndex === 0) {
        Styles.push(image);
        Styles.push(text);
      }
      if (sIndex === 1 || sIndex === 5) Styles.push(image);
      if (sIndex === 2 || sIndex === 7) Styles.push(icon);
      if (sIndex === 3) Styles.push(text);
      if (sIndex === 4 || sIndex === 6) {
        Styles.push(icon);
        Styles.push(text);
      }
      if (sIndex === 8) {
        Styles.push(image);
        Styles.push(icon);
        Styles.push(text);
      }
      if (sIndex === 9) {
        ////////////console.log('item',item)
        // ////////////////console.log('show4',item['show4'])
        if (item['showPlaceIcon'] == '是') {
          Styles.push(image);
        }
        if (item['showPlaceName'] == '是') {
          Styles.push(text);
        }
        if (item['showZhxyjsx'] == '是') {
          Styles.push(icon);
        }
        if (item['showXxhx'] == '是') {
          Styles.push(icon1);
        }
        if (item['showSfxk'] == '是') {
          Styles.push(icon2);
        }
      }
      return Styles;
    },
    /**
     * 单击点位操作
     */
    markerclick(evt) {
      ////////////console.log('markerclick',evt)
      // evt.preventDefault()
      if (this.isnotclick || this.iseditpoint) return;
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      this.$emit('markerclick', feature);
    },
    /**
     * 鼠标移入点位操作 动效
     */

    markermove(evt) {
      // 判断鼠标点位

      // 鼠标移开地图的时候，重置点位效果  
      // if(evt){
      //   this.createPoint (this.pointlist,{
      //     values_:{
      //       name:-1
      //     }
      //   })
      // }

      let currentPoint = '';
      let currentArea = '';
      if (this.drawflag || this.drawtextflag) {
        if (this.deleteflag) return;
        if (this.drawtextsingleflag) return;
        if (this.drawflag) this.helpTooltipElement.innerHTML = this.drawsketch ? '点击继续绘制线，双击结束绘制' : this.drawsketch ? '拖动修改' : '点击开始绘制';
        if (this.drawtextflag) this.helpTooltipElement.innerHTML = '点击选择位置后 添加点位名称';
        this.helpTooltip.setPosition(evt.coordinate);
        this.helpTooltipElement.classList.remove('hidden');
        return;
      }
      let sIndex = this.style.pointStyleIndex;
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      if (this.cfeature !== null) {
        let obj = {
          name: this.cfeature.get('name'),
          image: this.cfeature.get('image'),
          icon: this.cfeature.get('icon')
        };
        if (sIndex === 5) this.cfeature.setStyle(this.getStyle(obj, 1));
        if (sIndex === 6) this.cfeature.setStyle(this.getStyle(obj, 6));
        if (sIndex === 7) this.cfeature.setStyle(this.getStyle(obj, 7));
        // if (sIndex === 0) feature.setStyle(this.getStyle(obj, 9))
        this.cfeature = null;
      }
      this.map.getTarget().style.cursor = '';
      // 判断鼠标划过点位
      if (feature && feature.get('xy')) {
        this.map.getTarget().style.cursor = 'pointer';
        let cid = feature.get('id');
        let allfeatures = this.iconSource.getFeatures();
        allfeatures.forEach(item => {
          let id = item.get('id');
          let obj = {
            name: item.get('name'),
            image: item.get('image'),
            icon: item.get('icon')
          };
          if (cid === id) {
            currentPoint = item;
            this.cfeature = feature;
            if (this.currentArea) {
              if (this.currentArea.item) {
                this.currentArea.item.setVisible(true);
              }
              if (this.currentArea.current) {
                this.currentArea.item.setSource(new SourceImagestatic({
                  url: this.currentArea.current.image,
                  projection: 'EPSG:3857',
                  imageExtent: this.currentArea.extent
                }));
              }
            }
          }
        });
      }
      // 判断鼠标划过市区域
      if (feature && !feature.get('xy')) {
        let allfeatures = this.iconSource.getFeatures();
        this.currentArea = {};
        let code = Number(feature.get('adcode'));
        let geometry = feature.get('geometry');
        let current = this.hoverImgList.find(elem => {
          return elem.code === code;
        });
        let extent = geometry.extent_.map((item, index) => {
          if (index === 0 || index === 1) item = item - 600;
          if (index === 2 || index === 3) item = item + 600;
          return item;
        });
        // //console.log('!xy',evt)
        //       //console.log( geometry.extent_)
        // this.createPoint (this.pointlist,feature) 
        this.map.getLayers().getArray().forEach(item => {
          if (item.className_ === 'hoverimg') {
            if (item) {
              this.currentArea = {
                item: item,
                current: current,
                extent: extent
              };
            }
          }
        });
      }
      if (feature === undefined) {
        this.map.getLayers().getArray().forEach(item => {
          if (item.className_ === 'hoverimg') item.setVisible(false);
        });
      }
      let allfeatures = this.needAllFeture;
      allfeatures.forEach(e => {
        let obj = e.getStyle();
        if (obj[1]) {
          obj[1].text_.fill_ = new StyleFill({
            color: "#333333"
          });
          obj[1].text_.stroke_ = null;
          e.setStyle(obj);
        }
      });
      let dxq = '';
      // 襄阳都市圈
      const topLeftXy = [12330121.334888326, 3807405.389704013]; // 替换为实际坐标  
      const bottomLeftXy = [12329040.347432509, 3782542.7032834725]; // 替换为实际坐标  
      const topRightXy = [12485783.528526135, 3806324.4033379024]; // 替换为实际坐标  
      const bottomRightXy = [12485783.528526135, 3784704.6760156937]; // 替换为实际坐标  
      const mousePosition = this.map.getEventCoordinate(evt.originalEvent);
      const isInRectangleXy = mousePosition[0] >= bottomLeftXy[0] && mousePosition[0] <= topRightXy[0] && mousePosition[1] <= topLeftXy[1] && mousePosition[1] >= bottomRightXy[1];

      // 根据判断结果执行相应操作  
      if (isInRectangleXy) {
        dxq = '襄阳都市圈';
        ////console.log('allfeatures',allfeatures)
        allfeatures.forEach(e => {
          let obj = e.getStyle();
          if (e.getStyle()[1] && e.getStyle()[1].text_.dxq == dxq) {
            e.getStyle()[1].text_.preStyle = obj;
            obj[1].text_.fill_ = new StyleFill({
              color: '#ffffff'
            });
            obj[1].text_.stroke_ = new StyleStroke({
              color: '#045578',
              width: 2
            });
            e.setStyle(obj);
          } else {}
        });
        // this.createPoint (this.pointlist,null,allfeatures,dxq) 
      } else {}
      // 武汉都市圈
      const topLeftWh = [12710408.398191964, 3571750.361891935]; // 替换为实际坐标  
      const bottomLeftWh = [12709327.41537128, 3550130.6345697264]; // 替换为实际坐标  
      const topRightWh = [12862826.975908397, 3572831.348258046]; // 替换为实际坐标  
      const bottomRightWh = [12863907.95872908, 3547968.6618375056]; // 替换为实际坐标  
      const mousePositionWh = this.map.getEventCoordinate(evt.originalEvent);
      //////console.log(mousePositionWh)
      const isInRectangleWh = mousePositionWh[0] >= bottomLeftWh[0] && mousePositionWh[0] <= topRightWh[0] && mousePositionWh[1] <= topLeftWh[1] && mousePositionWh[1] >= bottomRightWh[1];
      // 根据判断结果执行相应操作  
      if (isInRectangleWh) {
        dxq = '武汉都市圈';
        allfeatures.forEach(e => {
          if (e.getStyle()[1] && e.getStyle()[1].text_.dxq == dxq) {
            let obj = e.getStyle();
            // ////console.log('e1234',obj)
            e.getStyle()[1].text_.preStyle = obj;
            obj[1].text_.fill_ = new StyleFill({
              color: '#ffffff'
            });
            obj[1].text_.stroke_ = new StyleStroke({
              color: '#045578',
              width: 2
            });
            e.setStyle(obj);
          } else {
            // e.setStyle(e.getStyle()[1].text_.preStyle)
          }
        });
        // this.createPoint (this.pointlist,null,allfeatures,dxq) 
      } else {}

      // 宜荆荆都市圈  
      const topLeftYjj = [12249909.716580614, 3593370.0892141443]; // 替换为实际坐标  
      const bottomLeftYjj = [12247747.750939246, 3567426.4164274936]; // 替换为实际坐标  
      const topRightYjj = [12440162.693020985, 3592289.102848034]; // 替换为实际坐标  
      const bottomRightYjj = [12438000.727379616, 3568507.402793604]; // 替换为实际坐标  
      const mousePositionYjj = this.map.getEventCoordinate(evt.originalEvent);
      const isInRectangleYjj = mousePositionYjj[0] >= bottomLeftYjj[0] && mousePositionYjj[0] <= topRightYjj[0] && mousePositionYjj[1] <= topLeftYjj[1] && mousePositionYjj[1] >= bottomRightYjj[1];
      // 根据判断结果执行相应操作  
      if (isInRectangleYjj) {
        dxq = '宜荆荆都市圈';
        allfeatures.forEach(e => {
          if (e.getStyle()[1] && e.getStyle()[1].text_.dxq == dxq) {
            let obj = e.getStyle();
            // ////console.log('e1234',obj)
            e.getStyle()[1].text_.preStyle = obj;
            obj[1].text_.fill_ = new StyleFill({
              color: '#ffffff'
            });
            obj[1].text_.stroke_ = new StyleStroke({
              color: '#045578',
              width: 2
            });
            e.setStyle(obj);
          } else {
            // e.setStyle(e.getStyle()[1].text_.preStyle)
          }
        });
        // this.createPoint (this.pointlist,null,allfeatures,dxq) 
      } else {}
    },
    /**
     * 地图移动结束操作
     */
    markermoveend(evt) {
      sessionStorage.removeItem('currentArea');
      const res = this.map.getView().getResolution();
      // ////////////////console.log('当前分辨率:', res)
      let zoom = Math.round(this.map.getView().getZoom());
      // ////////////////console.log('当前zoom:', zoom)
      if (this.defaultZoom === zoom && this.moveendflag) return false;
      if (this.defaultZoom !== zoom) this.defaultZoom = zoom;
      this.$emit('markermoveend', zoom);
    },
    changeToolHandle(val) {
      ////console.log('changeToolHandle')
      ////console.log(val)
      if (val !== '') this.isnotclick = true;
      if (val === 0 || val === 6) {
        this.deleteflag = false;
        this.createHelpTooltip();
        if (val === 0) this.showtexthelp();
      } else {
        if (this.helpTooltipElement) {
          this.helpTooltipElement.innerHTML === '';
          this.helpTooltipElement.classList.add('hidden');
        }
      }
      this.drawtextflag = val === 0 ? true : false;
      this.drawflag = val === 6 ? true : false;
      val === 6 ? this.addDrawInteractions() : this.removedrawInteractions();
      if (val === 2) {
        this.deleteflag = true;
        this.deleteDrawInteractions();
      }
      if (val === 3) {
        this.addselectInteraction();
        this.adddragboxInteraction();
      }
      if (val === 4) this.addtranslateInteraction();
    },
    /**
     * 地图添加 draw snap modify 交互效果
     */
    addDrawInteractions() {
      let that = this;
      this.drawinter = new Draw({
        source: this.drawSource,
        type: 'LineString',
        style: this.addStyle()
      });
      this.drawinter.on('drawstart', evt => {
        this.drawsketch = evt.feature;
        let sketch = evt.feature;
        sketch.set('dindex', this.findex);
        this.findex++;
      });
      this.drawinter.on('drawend', evt => {
        this.drawsketch = null;
      });
      this.map.addInteraction(this.drawinter);
      this.modifyinter = new Modify({
        source: this.drawSource,
        style: this.addStyle()
      });
      this.map.addInteraction(this.modifyinter);
      this.snapinter = new Snap({
        source: this.drawSource
      });
      this.map.addInteraction(this.snapinter);
      this.snapinter.on('snap', event => {
        this.helpTooltipElement.innerHTML = '拖动修改';
      });
    },
    getcurrentCoordinates(a1, a2) {
      let x1 = a1[0];
      let y1 = a1[1];
      let x2 = a2[0];
      let y2 = a2[1];
      let newCoordinate = [];
      if (x2 - x1 >= 0 && y2 - y1 >= 0 || x2 - x1 >= 0 && y2 - y1 <= 0 || x2 - x1 <= 0 && y2 - y1 >= 0 || x2 - x1 <= 0 && y2 - y1 <= 0) {
        if (Math.abs(x2 - x1) > Math.abs(y2 - y1)) {
          newCoordinate = [x2, y1];
        } else {
          newCoordinate = [x1, y2];
        }
      }
      return newCoordinate;
    },
    addStyle() {
      return new Style({
        stroke: new StyleStroke({
          color: '#2B67FF',
          width: 2
        }),
        image: new StyleCircle({
          radius: 5,
          fill: new StyleFill({
            color: '#2B67FF'
          })
        })
      });
    },
    /**
     * 地图移出 draw snap modify 交互效果
     */
    removedrawInteractions() {
      this.map.removeInteraction(this.modifyinter);
      this.modifyinter = '';
      this.map.removeInteraction(this.drawinter);
      this.drawinter = '';
      this.map.removeInteraction(this.snapinter);
      this.snapinter = '';
      this.map.removeInteraction(this.selectinter);
      this.selectinter = '';
      this.map.removeInteraction(this.dragboxinter);
      this.dragboxinter = '';
      this.map.removeInteraction(this.translateinter);
      this.translateinter = '';
    },
    /**
     * 创建提示信息
     */
    createHelpTooltip() {
      if (this.helpTooltipElement) this.helpTooltipElement.parentNode.removeChild(this.helpTooltipElement);
      this.helpTooltipElement = document.createElement('div');
      this.helpTooltipElement.className = 'ol-tooltip hidden';
      this.helpTooltip = new Overlay({
        element: this.helpTooltipElement,
        offset: [15, 0],
        positioning: 'center-left'
      });
      this.map.addOverlay(this.helpTooltip);
    },
    /**
     * 绘制删除操作
     */
    deleteDrawInteractions() {
      if (this.selectedFeatures.length === 0) {
        ElMessage({
          message: '请先选择要删除的绘制元素',
          type: 'warning'
        });
        return;
      }
      let deletedata = [];
      ElMessageBox.confirm('确定要删除么？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.selectedFeatures.getArray().forEach(feature => {
          if (feature.get('name')) deletedata.push({
            key: feature.get('id'),
            label: feature.get('name')
          });
          this.SET_MAPDRAWLAYERITEM({
            deleteList: deletedata
          });
          this.drawSource.removeFeature(feature);
        });
      }).catch(() => {
        this.selectedFeatures.clear();
      });
    },
    addselectInteraction() {
      this.selectinter = new Select({
        style: feature => {
          ////console.log('feature111')
          ////console.log(feature)
          let selectStyle = feature.getStyle();
          let score = feature.get('score');
          let type = feature.get('type');
          ////////////////console.log(selectStyle)
          ////////////////console.log(score)
          ////////////////console.log(type)
          ////////////////console.log(feature)
          if (score === 0) {
            selectStyle = [new Style({
              image: new StyleIcon({
                src: feature.get('image'),
                // anchor: [2.6, 0.5],
                anchor: [1.3, 0.5],
                scale: 0.05
              })
            }),
            // 这里是高亮效果
            new Style({
              text: new StyleText({
                textAlign: 'left',
                text: feature.get('name'),
                font: `14px sans-serif`,
                offsetY: 1,
                // offsetX: -30,
                fill: new StyleFill({
                  color: '#ffffff'
                }),
                stroke: new StyleStroke({
                  color: '#045578',
                  width: 2
                })
              })
            })];
          }
          if (type === 'areapolygon') {
            selectStyle = [new Style({
              fill: new StyleFill({
                color: 'rgba(255, 255, 255, 0.4)'
              }),
              stroke: new StyleStroke({
                color: '#045578',
                width: 2,
                lineDash: [6, 4]
              })
            })];
          }
          if (type === 'areaicon') {
            selectStyle = [new Style({
              image: new StyleIcon({
                src: require('@/assets/map/138053/circle.png'),
                // src: 'https://p.ananas.chaoxing.com/star3/origin/93f06f6eaf18f318ce99392322d2309d.png',
                scale: 1.8
                // scale: 0,
                // opacity:0
              })
            })];
          }
          return selectStyle;
        }
      });
      this.map.addInteraction(this.selectinter);
      // this.selectedFeatures = this.selectinter.getFeatures()
      let that = this;
      this.selectinter.on('select', function (evt) {
        if (that.selectinter.getFeatures().getArray().length === 0) {
          that.removeModify();
          that.removeTranslate();
        } else {
          let type = that.selectinter.getFeatures().getArray()[0].get('type');
          let dragId = that.selectinter.getFeatures().getArray()[0].get('id');
          console.log('type', type);
          console.log('dragId', dragId);
          if (type && type.includes('area')) {
            /** 选中当前区域列表、ICON、LINE  **/
            console.log('that.areaList', that.areaList);
            let selectItem = that.onlyAreaList(that.areaList).find(item => {
              return item.id === dragId;
            });
            console.log('selectItem', selectItem);
            //console.log('that.onlyAreaList(that.areaList)',that.onlyAreaList(that.areaList))
            //console.log('dragId',dragId)

            that.setSelectData(selectItem);
            that.adddrawSourceTranslate();
          } else {
            let selectItem;
            that.onlyAreaList(that.areaList).forEach(item => {
              if (item.data.length > 0) {
                item.data.forEach(elem => {
                  if (elem === dragId) selectItem = item;
                });
              }
            });
            //console.log(`selectItem`, selectItem);
            if (selectItem) that.setSelectData(selectItem);
            that.addiconSourceModify(selectItem);
          }
        }
      });
    },
    removeModify() {
      this.map.removeInteraction(this.modifyinter);
      this.modifyinter = '';
    },
    removeTranslate() {
      this.map.removeInteraction(this.translateinter);
      this.translateinter = '';
    },
    // 点击后，鼠标划过出现点
    addiconSourceModify(item) {
      /* item值为undefined 说明areaList无该点位数据 */
      let that = this;
      this.modifyinter = new Modify({
        source: this.iconSource,
        style: this.addStyle()
      });
      ////////////////console.log(this.addStyle())
      this.map.addInteraction(this.modifyinter);
      this.modifyinter.on('modifystart', function (evt) {});
      this.modifyinter.on('modifyend', function (evt) {
        let coodrs = evt.features.getArray()[0].getGeometry().getCoordinates();
        console.log('evt.features.getArray()[0]');
        console.log(evt.features.getArray()[0]);
        let isExistpolygon;
        that.drawSource.getFeatures().forEach(feature => {
          if (feature.get('type') === 'areapolygon') {
            let extent = feature.getGeometry().getExtent();
            if (coodrs[0] <= extent[2] && coodrs[0] >= extent[0] && coodrs[1] <= extent[3] && coodrs[1] >= extent[1]) isExistpolygon = feature;
          }
        });
        console.log('isExistpolygon');
        console.log(isExistpolygon);
        console.log('item');
        console.log(item);
        /* 新增点 */
        if (isExistpolygon !== undefined && item === undefined) {
          let dragId = isExistpolygon.get('id');
          let areaIndex = that.onlyAreaList(that.areaList).findIndex(item => {
            return item.id === dragId;
          });
          that.setSelectData(that.onlyAreaList(that.areaList)[areaIndex]);
          that.polygonchangefeature(evt.features.getArray()[0], 0, areaIndex);
          that.onlyAreaList(that.areaList)[areaIndex].data.push(evt.features.getArray()[0].get('id'));
        }
        /* 删除点 */
        if (isExistpolygon === undefined && item !== undefined) {
          let areaIndex, dataIndex;
          that.onlyAreaList(that.areaList).forEach((item, index) => {
            item.data.forEach((elem, eIndex) => {
              if (elem === evt.features.getArray()[0].get('id')) {
                areaIndex = index;
                dataIndex = eIndex;
              }
            });
          });
          that.polygonchangefeature(evt.features.getArray()[0], 1, areaIndex);
          if (that.selectArr.length > 0) that.onlyAreaList(that.areaList)[areaIndex].data.splice(dataIndex, 1);
        }
      });
    },
    /**
    * 区域列表新增或删除点位操作 type 0新增  1删除
    */
    polygonchangefeature(feature, type, areaIndex) {
      console.log(`type`, type === 0 ? '添加' : '删除');
      console.log('selectArr');
      console.log(this.selectArr);
      //console.log('areaIndex')
      //console.log(this.areaIndex)
      //console.log('feature')
      //console.log(feature)
      if (type === 0) this.selectArr.push(feature);
      if (type === 1) {
        let index = this.selectArr.findIndex(item => item.get('id') === feature.get('id'));
        this.selectArr.splice(index, 1);
        feature.getGeometry().setCoordinates(transform(feature.get('xy'), 'EPSG:4326', 'EPSG:3857'));
      }
      this.selectinter.getFeatures().clear();
      this.removeModify();
      /** 区域列表内无点位数据操作 **/
      if (this.selectArr.length === 0) {
        let boxid = this.onlyAreaList(this.areaList)[areaIndex].id;
        this.drawSource.getFeatures().forEach(feature => {
          if (feature.get('id') === boxid) this.drawSource.removeFeature(feature);
        });
        this.onlyAreaList(this.areaList).splice(areaIndex, 1);
      } else {
        let center = this.pointIcon.getGeometry().getCoordinates();
        this.setpointCoordinates(center, type);
        this.polygonfeature.setGeometry(new Polygon([this.getPolygonCoords()]));
        this.onlyAreaList(this.areaList)[areaIndex].datafirstcenter = this.selectArr[0].getGeometry().getCoordinates();
        this.onlyAreaList(this.areaList)[areaIndex].iconcenter = this.pointIcon.getGeometry().getCoordinates();
      }
    },
    setSelectData(select) {
      if (select == undefined) return;
      this.selectArr = [];
      console.log('setSelectData');
      console.log(select);
      select.data.forEach(item => {
        this.iconSource.getFeatures().forEach(feature => {
          if (item === feature.get('id')) this.selectArr.push(feature);
        });
      });
      this.drawSource.getFeatures().forEach(feature => {
        console.log('feature', feature);
        if (feature.get('id') === select.id) {
          if (feature.get('type') === 'areaicon') this.pointIcon = feature;
          if (feature.get('type') === 'areapolygon') this.polygonfeature = feature;
          if (feature.get('type') === 'arealine') this.linefeature = feature;
        }
      });
    },
    // addselectInteraction () {
    //   this.selectinter = new Select({
    //     style: (feature) => {
    //       let featuretype = feature.getGeometry().getType()
    //       if (featuretype !== 'LineString' && featuretype !== 'Point' && featuretype !== 'Circle') return
    //       let textstyle = this.currentTextstyle
    //       if (feature.get('name')) textstyle = feature.get('style')
    //       return new Style({
    //         fill: new StyleFill({ color: '#2B67FF' }),
    //         stroke: new StyleStroke({
    //           color: '#2B67FF', width: feature.get('type') === 'circle' ? this.CircleRadius : 2
    //         }),
    //         text: feature.get('name') ? new StyleText({
    //           text: textstyle.align === 0 ? feature.get('name').split('').join('\n') : feature.get('name'),
    //           font: `${textstyle.fontSize}px FZShengShiKaiShuS-DB-GB`,
    //           textBaseline: 'top',
    //           textAlign: 'left',
    //           fill: new StyleFill({color: '#2B67FF'})
    //         }) : ''
    //       })
    //     }
    //   })

    //   this.map.addInteraction(this.selectinter)
    //   this.selectedFeatures = this.selectinter.getFeatures()
    // },
    /**
     * 选择绘制元素
     */
    // addselectInteraction () {
    //   this.selectinter = new Select({
    //     style: (feature) => {
    //       let featuretype = feature.getGeometry().getType()
    //       if (featuretype !== 'LineString' && featuretype !== 'Point' && featuretype !== 'Circle') return
    //       let textstyle = this.currentTextstyle
    //       if (feature.get('name')) textstyle = feature.get('style')
    //       return new Style({
    //         fill: new StyleFill({ color: '#2B67FF' }),
    //         stroke: new StyleStroke({
    //           color: '#2B67FF', width: feature.get('type') === 'circle' ? this.CircleRadius : 2
    //         }),
    //         text: feature.get('name') ? new StyleText({
    //           text: textstyle.align === 0 ? feature.get('name').split('').join('\n') : feature.get('name'),
    //           font: `${textstyle.fontSize}px FZShengShiKaiShuS-DB-GB`,
    //           textBaseline: 'top',
    //           textAlign: 'left',
    //           fill: new StyleFill({color: '#2B67FF'})
    //         }) : ''
    //       })
    //     }
    //   })

    //   this.map.addInteraction(this.selectinter)
    //   this.selectedFeatures = this.selectinter.getFeatures()
    // },
    /**
     * 
     * 框选绘制元素
     */
    // adddragboxInteraction () {
    //   this.dragboxinter = new DragBox({
    //     condition: platformModifierKeyOnly,
    //   })
    //   this.dragboxinter.on('boxstart', () => {
    //     this.selectedFeatures.clear()
    //   })
    //   this.dragboxinter.on('boxend', () => {
    //     const boxExtent = this.dragboxinter.getGeometry().getExtent()
    //     const worldExtent = this.map.getView().getProjection().getExtent()
    //     const worldWidth = getWidth(worldExtent)
    //     const startWorld = Math.floor((boxExtent[0] - worldExtent[0]) / worldWidth)
    //     const endWorld = Math.floor((boxExtent[2] - worldExtent[0]) / worldWidth)
    //     for (let world = startWorld; world <= endWorld; ++world) {
    //       const left = Math.max(boxExtent[0] - world * worldWidth, worldExtent[0])
    //       const right = Math.min(boxExtent[2] - world * worldWidth, worldExtent[2])
    //       const extent = [left, boxExtent[1], right, boxExtent[3]]
    //       const boxFeatures = this.drawSource.getFeaturesInExtent(extent).filter((feature) =>
    //         !this.selectedFeatures.getArray().includes(feature) &&
    //         feature.getGeometry().intersectsExtent(extent),
    //       )
    //       const rotation = this.map.getView().getRotation()
    //       const oblique = rotation % (Math.PI / 2) !== 0
    //       if (oblique) {
    //         const anchor = [0, 0]
    //         const geometry = this.dragboxinter.getGeometry().clone()
    //         geometry.translate(-world * worldWidth, 0)
    //         geometry.rotate(-rotation, anchor)
    //         const extent = geometry.getExtent()
    //         boxFeatures.forEach(function (feature) {
    //           const geometry = feature.getGeometry().clone()
    //           geometry.rotate(-rotation, anchor)
    //           if (geometry.intersectsExtent(extent)) {
    //             this.selectedFeatures.push(feature)
    //           }
    //         })
    //       } else {
    //         this.selectedFeatures.extend(boxFeatures)
    //       }
    //     }
    //     let that = this

    //   })
    //   this.map.addInteraction(this.dragboxinter)
    // },
    /**
     * 平移绘制元素
     */
    drawAreaList(val) {
      console.log(' this.drawelement.drawarea');
      console.log(this.drawelement.drawarea);

      // 存在点位区域列表数据
      if (Object.keys(this.drawelement).length > 0 && this.drawelement.drawarea) {
        if (this.iseditpoint) this.$emit('drawarea', true);
        this.viewratio = this.map.getView().getResolution();
        this.map.getLayers().getArray().forEach(item => {
          ////////////////console.log('item',item)
          if (item.className_ === 'icon') item.setZIndex(7);
          if (item.className_ === 'draw') item.setZIndex(6);
        });
        ////////////////console.log(`this.drawelement.drawarea`, this.drawelement.drawarea)
        this.drawelement.drawarea.forEach(area => {
          console.log('area', area);
          this.pointIcon = new Feature({
            geometry: new Point(area.iconcenter),
            id: area.id,
            type: 'areaicon'
          });
          this.pointIcon.setStyle(new Style({
            image: new StyleIcon({
              src: require('@/assets/map/138053/circle.png'),
              opacity: this.formUserId == 1514653091 ? 0 : 1
              // src: 'https://p.ananas.chaoxing.com/star3/origin/93f06f6eaf18f318ce99392322d2309d.png',
              // opacity:0
            })
          }));
          this.drawSource.addFeature(this.pointIcon);
          let features = [];
          let slen = features.length;
          let px = area.datafirstcenter[0];
          let py = area.datafirstcenter[1];
          this.increase = this.viewratio * this.ih;
          this.transdiffx = area.datafirstcenter[0] - area.iconcenter[0];
          area.data.forEach((elem, index) => {
            this.iconSource.getFeatures().forEach(feature => {
              if (elem === feature.get('id')) {
                let len = feature.get('name').length;
                this.nmaxlen = this.nmaxlen <= len ? len : this.nmaxlen;
                feature.getGeometry().setCoordinates([px, py + (index !== 0 ? -index * this.increase : 0)]);
                features.push(feature);
              }
            });
          });
          let polygonextent = this.setpolyonextent(features);
          this.polygonfeature = new Feature({
            geometry: new Polygon([this.extentToPolygonCoords(polygonextent)]),
            id: area.id,
            type: 'areapolygon'
          });
          //     this.polygonfeature.setStyle(new Style({
          //   fill: new StyleFill({ color: 'rgba(255, 255, 255, 0.4)' }),
          //   stroke: new StyleStroke({
          //     color: '#045578',
          //     width: 1,
          //     lineDash: [6, 4]
          //   })
          // }))
          this.polygonfeature.setStyle(new Style({
            fill: new StyleFill({
              color: 'rgba(255, 255, 255, 0)'
            }),
            stroke: new StyleStroke({
              color: 'rgba(255, 255, 255, 0)',
              width: 0
            })
          }));
          // this.polygonfeature.setStyle(new Style({
          //     fill: new StyleFill({ color: 'rgba(255, 255, 255, 1)' }),
          // stroke: new StyleStroke({
          //   color: 'rgba(255, 255, 255, 1)',
          //   width: 1,
          // })
          //   }))
          this.drawSource.addFeature(this.polygonfeature);
          /** 判断line在pointIcon 左侧(false)或右侧(true) **/
          let direction = polygonextent[0] > area.iconcenter[0];
          let polygonwidth = polygonextent[2] - polygonextent[0];
          this.linefeature = new Feature({
            geometry: new LineString([area.iconcenter, [polygonextent[0] + (direction ? 0 : polygonwidth), area.iconcenter[1]]]),
            id: area.id,
            type: 'arealine'
          });
          //   this.linefeature.setStyle(new Style({
          //     stroke: new StyleStroke({
          //   // color: 'rgba(0,0,0,0)',
          //   // width: 4,
          //   // lineDash: [6, 4]
          //   color: 'rgba(0, 56, 238, 0.35)',
          //   width: 4,
          //   // lineDash: [6, 4]
          // })
          //   }))
          if (this.formUserId == 1514653091) {
            this.linefeature.setStyle(new Style({
              stroke: new StyleStroke({
                color: 'rgba(0,0,0,0)',
                width: 4,
                lineDash: [6, 4]
                // color: 'rgba(0, 56, 238, 0.35)',
                // width: 4,
              })
            }));
          } else {
            this.linefeature.setStyle(new Style({
              stroke: new StyleStroke({
                // color: 'rgba(0,0,0,0)',
                // width: 4,
                // lineDash: [6, 4]
                color: 'rgba(0, 56, 238, 0.35)',
                width: 4
              })
            }));
          }
          this.drawSource.addFeature(this.linefeature);
        });
        this.areaList = this.drawelement.drawarea;
        // ////console.log(this.drawelement.drawarea)
      }
    },
    adddragboxInteraction() {
      this.dragboxinter = new DragBox({
        condition: platformModifierKeyOnly
      });
      this.map.addInteraction(this.dragboxinter);
      this.dragboxinter.on('boxstart', () => {
        this.selectedFeatures = [];
      });
      this.dragboxinter.on('boxend', () => {
        const boxExtent = this.dragboxinter.getGeometry().getExtent();
        const worldExtent = this.map.getView().getProjection().getExtent();
        const worldWidth = getWidth(worldExtent);
        const startWorld = Math.floor((boxExtent[0] - worldExtent[0]) / worldWidth);
        const endWorld = Math.floor((boxExtent[2] - worldExtent[0]) / worldWidth);
        for (let world = startWorld; world <= endWorld; ++world) {
          const left = Math.max(boxExtent[0] - world * worldWidth, worldExtent[0]);
          const right = Math.min(boxExtent[2] - world * worldWidth, worldExtent[2]);
          const extent = [left, boxExtent[1], right, boxExtent[3]];
          const boxFeatures = this.iconSource.getFeaturesInExtent(extent).filter(feature => feature.getGeometry().intersectsExtent(extent));
          this.selectedFeatures = boxFeatures;
        }
        let that = this;
        //console.log('this.selectedFeatures',this.selectedFeatures)
        this.resetAreaParams();
        if (this.jsonOption.drawlayer && this.jsonOption.drawlayer.drawarea.length) {
          this.boxId = this.jsonOption.drawlayer.drawarea.length + 1;
        } else {
          this.boxId++;
        }
        //console.log('this.boxId')
        //console.log(this.boxId)
        this.editareaList(this.selectedFeatures);
        this.$emit('drawarea', true);
        this.dialogVisible = true;
      });
    },
    adddrawSourceTranslate() {
      let that = this;
      this.translateinter = new Translate({
        features: this.selectinter.getFeatures()
      });
      this.map.addInteraction(this.translateinter);

      /** 拖拽列表区域控制在ICON左侧或右侧  拖拽ICON 整体随之改变位置  **/
      let startCoords, startpolygonCoords, startlineCoords, polygonwidth, startSelectArr, starticonCoords, dragelemtype, dragelemgId;
      this.translateinter.on('translatestart', function (evt) {
        //console.log(`translatestart`, evt);
        dragelemtype = evt.features.getArray()[0].get('type');
        // dragelemgId = evt.features.getArray()[0].get('id')
        dragelemgId = evt.features.getArray()[0].get('id');
        startCoords = evt.startCoordinate;
        starticonCoords = that.pointIcon.getGeometry().getCoordinates();
        startpolygonCoords = that.polygonfeature.getGeometry().getCoordinates();
        startlineCoords = that.linefeature.getGeometry().getCoordinates();
        polygonwidth = startpolygonCoords[0][1][0] - startpolygonCoords[0][0][0];
        startSelectArr = _.cloneDeep(that.selectArr);
        // console.log('dragelemtype',dragelemtype)
        // console.log('dragelemgId',dragelemgId)
        // console.log('startCoords',startCoords)
        // console.log('starticonCoords',starticonCoords)
        // console.log('startpolygonCoords',startpolygonCoords)
        // console.log('startlineCoords',startlineCoords)
        // console.log('polygonwidth',polygonwidth)
        // console.log('startSelectArr',startSelectArr)
      });
      this.translateinter.on('translating', function (evt) {
        that.transdiffx = evt.coordinate[0] - startCoords[0];
        that.transdiffy = evt.coordinate[1] - startCoords[1];
        let translatepolygonCoords = startpolygonCoords[0].map(item => {
          return [item[0] + that.transdiffx, item[1] + (dragelemtype === 'areaicon' ? that.transdiffy : 0)];
        });
        that.polygonfeature.setGeometry(new Polygon([translatepolygonCoords]));
        //console.log('translating')
        //console.log(startpolygonCoords)
        //console.log(translatepolygonCoords)
        that.selectArr.forEach((elem, index) => {
          let select = startSelectArr[index].getGeometry().getCoordinates();
          elem.getGeometry().setCoordinates([select[0] + that.transdiffx, select[1] + (dragelemtype === 'areaicon' ? that.transdiffy : 0)]);
        });

        /** 判断polygon在pointIcon 左侧(false)或右侧(true) **/
        let direction = evt.coordinate[0] > startlineCoords[0][0];
        let translatelineCoords;
        if (dragelemtype === 'areaicon') {
          translatelineCoords = startlineCoords.map((item, index) => {
            return [item[0] + that.transdiffx, item[1] + that.transdiffy];
          });
          //console.log('areaicon')
          //console.log(startlineCoords)
        } else {
          //console.log('startlineCoords')
          //console.log(startlineCoords)
          translatelineCoords = startlineCoords.map((item, index) => {
            if (index === 1) item = [translatepolygonCoords[1][0] - (direction ? polygonwidth : 0), item[1]];
            return item;
          });
        }
        that.linefeature.setGeometry(new LineString(translatelineCoords));
      });
      this.translateinter.on('translateend', function (evt) {
        // //console.log(789)
        // //console.log(that.areaList)
        let areaIndex = that.areaList.findIndex(item => {
          return item.id === dragelemgId;
        });
        that.areaList[areaIndex].datafirstcenter = that.selectArr[0].getGeometry().getCoordinates();
        that.areaList[areaIndex].iconcenter = that.pointIcon.getGeometry().getCoordinates();
        // //console.log('dragelemgId')
        // //console.log(dragelemgId)
        // //console.log('that.areaList[areaIndex].datafirstcenter')
        // //console.log(that.areaList[areaIndex].datafirstcenter)
        // //console.log('that.areaList[areaIndex].iconcenter')
        // //console.log(that.areaList[areaIndex].iconcenter)
      });
    },
    editareaList(val) {
      if (val.length == 0) return;
      this.viewratio = this.map.getView().getResolution();
      this.map.getLayers().getArray().forEach(item => {
        if (item.className_ === 'icon') item.setZIndex(7);
        if (item.className_ === 'draw') item.setZIndex(6);
      });
      this.selectArr = val;
      let extent = boundingExtent(this.selectArr.map(feature => feature.getGeometry().getCoordinates()));
      //console.log('extent')
      //console.log(extent)
      //console.log('this.selectArr')
      //console.log(this.selectArr)
      let center = getCenter(extent);
      // 隐藏掉圆圈
      this.pointIcon = new Feature({
        geometry: new Point(center),
        id: this.boxId,
        type: 'areaicon'
      });
      this.pointIcon.setStyle(new Style({
        image: new StyleIcon({
          src: require('@/assets/map/138053/circle.png'),
          opacity: this.formUserId == 1514653091 ? 0 : 1
        })
      }));
      this.drawSource.addFeature(this.pointIcon);
      this.drift = this.viewratio * 300;
      this.increase = this.viewratio * this.ih;
      this.setpointCoordinates(center);

      // 隐藏掉边框

      this.polygonfeature = new Feature({
        geometry: new Polygon([this.getPolygonCoords()]),
        id: this.boxId,
        type: 'areapolygon'
      });
      this.polygonfeature.setStyle(new Style({
        fill: new StyleFill({
          color: 'rgba(255, 255, 255, 0)'
        }),
        stroke: new StyleStroke({
          color: 'rgba(255, 255, 255, 0)',
          width: 0
        })
      }));
      // this.polygonfeature.setStyle(new Style({
      //   fill: new StyleFill({ color: 'rgba(255, 255, 255, 1)' }),
      //   stroke: new StyleStroke({
      //     color: 'rgba(255, 255, 255, 1)',
      //     width: 1,
      //   })
      // }))
      this.drawSource.addFeature(this.polygonfeature);
      // 隐藏掉线
      this.linefeature = new Feature({
        geometry: new LineString([center, [center[0] + this.drift - this.viewratio * 34 * 3, center[1]]]),
        id: this.boxId,
        type: 'arealine'
      });
      if (this.formUserId == 1514653091) {
        this.linefeature.setStyle(new Style({
          stroke: new StyleStroke({
            color: 'rgba(0,0,0,0)',
            width: 4,
            lineDash: [6, 4]
          })
        }));
      } else {
        this.linefeature.setStyle(new Style({
          stroke: new StyleStroke({
            color: 'rgba(0, 56, 238, 0.35)',
            width: 4
          })
        }));
      }
      this.drawSource.addFeature(this.linefeature);
      let dataId = this.selectArr.map(item => {
        return item.get('id');
      });
      this.areaList.push({
        id: this.boxId,
        iconcenter: center,
        data: dataId,
        datafirstcenter: this.selectArr[0].getGeometry().getCoordinates()
      });
    },
    setpointCoordinates(center, type) {
      let slen = this.selectArr.length;
      let px = center[0];
      let py = Math.abs(center[1] + this.viewratio * this.ih * (slen - 1) / 2);
      this.selectArr.forEach((elem, index) => {
        let len = elem.get('name').length;
        this.nmaxlen = this.nmaxlen <= len ? len : this.nmaxlen;
        let coords = elem.getGeometry().getCoordinates();
        let x = px + this.drift;
        if (this.transdiffx !== 0) {
          x = coords[0];
          if (type === 0 && index === slen - 1) x = this.selectArr[0].getGeometry().getCoordinates()[0];
        }
        elem.getGeometry().setCoordinates([x, py + (index !== 0 ? -index * this.increase : 0)]);
      });
    },
    getPolygonCoords() {
      return this.extentToPolygonCoords(this.setpolyonextent(this.selectArr));
    },
    setpolyonextent(features) {
      //console.log('setpolyonextent')
      //console.log(features)
      //console.log(features.map(feature => feature.getGeometry().getCoordinates()))
      let polygonextent = boundingExtent(features.map(feature => feature.getGeometry().getCoordinates()));
      //console.log(polygonextent)
      polygonextent[0] = polygonextent[0] - this.viewratio * 34;
      polygonextent[1] = polygonextent[1] - this.viewratio * 18;
      polygonextent[2] = polygonextent[2] + this.nmaxlen * 12 * this.viewratio;
      polygonextent[3] = polygonextent[3] + this.viewratio * 18;
      return polygonextent;
    },
    extentToPolygonCoords(extent) {
      return [[extent[0], extent[1]],
      // 左上角
      [extent[2], extent[1]],
      // 右上角
      [extent[2], extent[3]],
      // 右下角
      [extent[0], extent[3]],
      // 左下角
      [extent[0], extent[1]] // 闭合
      ];
    },
    resetAreaParams() {
      this.pointIcon = '';
      this.polygonfeature = '';
      this.linefeature = '';
      this.nmaxlen = 0;
      this.drift = 0;
      this.increase = 0;
      this.transdiffx = 0;
      this.transdiffy = 0;
    },
    addtranslateInteraction() {
      if (this.selectedFeatures.length === 0) {
        ElMessage({
          message: '请先选择要平移的绘制元素',
          type: 'warning'
        });
        return;
      }
      this.translateinter = new Translate({
        features: this.selectedFeatures
      });
      this.map.addInteraction(this.translateinter);
    },
    /**
     * 绘制文字
     */
    createText(val, name) {
      ////////////////console.log(`绘制文字`, val)
      this.drawSource.getFeatures().forEach(feature => {
        if (feature.get('type') === 0) this.drawSource.removeFeature(feature);
      });
      let data = this.mapv2info.drawlayer;
      let iconFeatures = [];
      let list = name === 'currentList' ? val : data.currentList;
      list.forEach((elem, index) => {
        let coordinate = [...data.currentCoordinate];
        let cstyle = {
          ...this.currentTextstyle
        };
        cstyle.color = (index - 1) % 3 === 0 ? cstyle.color2 : cstyle.color1;
        let space = cstyle.fontSpace ? cstyle.fontSpace : 4;
        if (cstyle.align === 0) coordinate[0] = coordinate[0] + index * (cstyle.fontSize * space * 0.001);
        if (cstyle.align === 1) coordinate[1] = coordinate[1] - index * (cstyle.fontSize * space * 0.001);
        let feature = new Feature({
          geometry: new Point(transform(coordinate, 'EPSG:4326', 'EPSG:3857')),
          id: elem.key,
          name: elem.label,
          type: name === 'currentList' ? 0 : val,
          style: cstyle
        });
        let text = elem.label;
        if (cstyle.align === 0) {
          elem.label = elem.label.replace(/\uff08/g, '\ufe35');
          elem.label = elem.label.replace(/\uff09/g, '\ufe36');
          text = elem.label.split('').join('\n');
        }
        feature.setStyle(new Style({
          text: new StyleText({
            text: text,
            font: `${cstyle.fontSize}px FZShengShiKaiShuS-DB-GB`,
            textBaseline: 'top',
            textAlign: 'left',
            fill: new StyleFill({
              color: cstyle.color
            })
          })
        }));
        iconFeatures.push(feature);
      });
      this.drawSource.addFeatures(iconFeatures);
      if (name === 'drawtextblocksum') {
        this.SET_MAPDRAWLAYERITEM({
          currentList: []
        });
        this.showtexthelp();
      }
    },
    showtexthelp() {
      this.drawtextsingleflag = false;
      this.helpTooltipElement.innerHTML = '点击选择位置后 添加点位名称';
      this.helpTooltipElement.classList.remove('hidden');
    },
    /**
     * 保存绘制数据
     */
    saveDrawHandle() {
      let feature = this.drawSource.getFeatures();
      let jsonObj = new GeoJSON().writeFeatures(feature);
      this.SET_MAPDRAWLAYERITEM({
        drawJson: feature.length > 0 ? jsonObj : ''
      });
    },
    /**
     * 创建非遗数据点位
     */
    createculturalPoint(val) {
      if (val.length === 0) return;
      let showArr = val.filter(item => {
        return item.itemformdata.correlation_map === '是' && item.itemformdata.correlation_address.length > 0;
      });
      showArr.forEach(elem => {
        let item = elem.itemformdata;
        // 有坐标的显示
        let gd = bd_decrypt(Number(item.correlation_address[0].lng), Number(item.correlation_address[0].lat));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        let obj = {
          name: item.title,
          image: item.icon ? item.icon : this.defaulticon,
          icon: ''
        };
        let pointfeature = new Feature({
          geometry: new Point(fromLonLat([x, y])),
          id: elem.id,
          name: obj.name,
          image: obj.image,
          icon: '',
          xy: [x, y],
          score: 0
        });
        pointfeature.setStyle(this.getStyle(obj, 1));
        this.iconSource.addFeature(pointfeature);
      });
      // 龙岩地图添加 随机显示 gif动图 20240529 后面可以在高级设置的 交互效果 做统一对接
      if (this.$route.query.fid === '138053') {
        this.setpointlight(showArr);
      }
    },
    setpointlight(arr) {
      let that = this;
      let len = arr.length;
      let max = len / 3;
      let newIndexArr = [];
      for (let i = 0; i < 6; i++) {
        let randIndex = Math.floor(Math.random() * len);
        if (!newIndexArr.includes(randIndex)) newIndexArr.push(randIndex);
      }
      newIndexArr.forEach(elem => {
        let item = arr[elem].itemformdata;
        // 有坐标的显示
        let gd = bd_decrypt(Number(item.correlation_address[0].lng), Number(item.correlation_address[0].lat));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        let obj = {
          name: item.title,
          image: this.lightIcon[Math.floor(Math.random() * 3)],
          icon: '',
          gif: this.lightIcon[Math.floor(Math.random() * 3)]
        };
        let pointfeature = new Feature({
          geometry: new Point(fromLonLat([x, y])),
          id: arr[elem].id,
          name: obj.name,
          image: obj.image,
          icon: '',
          xy: [x, y],
          // score: 1,
          score: 0,
          light: true
        });
        const gifUrl = obj.gif;
        const gif = gifler(gifUrl);
        gif.frames(document.createElement('canvas'), function (ctx, frame) {
          if (!pointfeature.getStyle()) {
            pointfeature.setStyle(new Style({
              image: new StyleIcon({
                img: ctx.canvas,
                opacity: 1,
                imgSize: [frame.width, frame.height],
                anchor: [0.5, 0.5],
                scale: 0.02
              })
            }));
          }
          ctx.clearRect(0, 0, frame.width, frame.height);
          ctx.drawImage(frame.buffer, frame.x, frame.y);
          that.map.render();
        }, true);
        this.iconSource.addFeature(pointfeature);
      });
    },
    addpopOverLay(coordinate) {
      const container = document.querySelector('.popcontainer-style1');
      this.overlay = new Overlay({
        element: container,
        positioning: 'bottom-left'
      });
      this.overlay.setPosition(fromLonLat(coordinate));
      this.map.addOverlay(this.overlay);
    },
    removeAlliconsource() {
      this.iconSource.clear();
    },
    removeDrawsource() {
      this.drawSource.clear();
    },
    removeRoutesource() {
      this.routeSource.clear();
    },
    createRoute(val) {
      //console.log(`createRoute`, val)
      if (val.length === 0) return;
      this.routeSource.clear();
      let routeFeatures = [];
      this.allpath = [];
      this.routeData = _.cloneDeep(val);
      val.forEach((item, index) => {
        let linestyle = {
          ...item.style
        };
        if (linestyle.lineDash) {
          linestyle.lineDash.length > 0 ? linestyle.lineDash = linestyle.lineDash.map(item => {
            return linestyle.width * item;
          }) : delete linestyle.lineDash;
        }
        if (index === 0) this.routeStyle = linestyle;
        item.path.forEach((child, cdi) => {
          let gemoetry = new LineString(child);
          if (item.routelinetype === 3 && child.length > 2) {
            this.curverouteCoords[cdi] = child.slice(1, -1);
            gemoetry = new LineString(createBezierCurvePoints(child.length - 1, child));
          }
          let routeFeature = new Feature({
            id: item.id ? item.id : cdi,
            type: 'allroute',
            geometry: gemoetry
          });
          routeFeature.setStyle(new Style({
            stroke: new StyleStroke(linestyle)
          }));
          routeFeatures.push(routeFeature);
          let itemcoords = gemoetry.getCoordinates();
          if (gemoetry.getCoordinates().length === 2) itemcoords = getPointsBetweenLatLong(itemcoords[0][1], itemcoords[0][0], itemcoords[1][1], itemcoords[1][0], 100);
          this.allpath.push(...itemcoords);
        });
      });
      this.saveCurverouteCoords(false);
      this.routeSource.addFeatures(routeFeatures);

      // 若线段的类型 是曲线且配置页打开时 开启绘制曲线功能
      if (val[0].isCurve) {
        ////////////////console.log(`开启绘制曲线功能`);
        this.addCurveselectInteraction();
      }
      this.startMove();
      // 移动端显示路线后 路线的初始经纬度挪到地图的中心点 防止看不到
      if (this.isMobile && val.length === 1) this.map.getView().animate({
        center: val[0].path[0][0]
      });
    },
    startMove() {
      this.geoMarker = new Feature({
        type: 'geoMarker',
        geometry: new Point(this.allpath[0])
      });
      this.geoMarker.setStyle(new Style({
        // 设置标记样式
        image: new StyleIcon({
          anchor: [0.5, 1],
          // 偏移位置
          src: this.moveicon,
          rotateWithView: true,
          opacity: 0
        })
      }));
      this.routeSource.addFeature(this.geoMarker);
      this.nowDate = new Date().getTime();
      this.animating = true;
      this.routeLayer.on('postrender', this.moveFeature);
      this.map.render();
    },
    moveFeature(event) {
      let vectorContext = olRender.getVectorContext(event);
      let frameState = event.frameState;
      let speed = this.allpath.length / 4;
      if (this.animating) {
        let elapsedTime = frameState.time - this.nowDate;
        let index = Math.round(speed * elapsedTime / 1000);
        // 进度条
        this.moveprogress = Math.floor(100 / this.allpath.length * (speed * elapsedTime) / 1000);
        if (index >= this.allpath.length) {
          this.moveprogress = '100';
          this.stopMove(true);
          return;
        }
        let currentPoint = new Point(this.allpath[index]);
        let feature = new Feature(currentPoint);
        vectorContext.drawFeature(feature, new Style({
          // 设置标记样式
          image: new StyleIcon({
            anchor: [0.5, 1],
            // 偏移位置
            src: this.moveicon,
            rotateWithView: true
          })
        }));
      }
      // tell OpenLayers to continue the postrender animation
      this.map.render();
    },
    stopMove(ended) {
      this.moveprogress = 0;
      this.animating = false;
      let coord = ended ? this.allpath[this.allpath.length - 1] : this.allpath[0];
      this.geoMarker.getGeometry().setCoordinates(coord);
      //remove listener
      this.routeLayer.un('postrender', this.moveFeature); // 删除侦听器
    },
    loadLocation(val) {
      this.locationSource.clear();
      if (Object.keys(val).length > 0 && val.lng && val.lat) {
        let gd = bd_decrypt(val.lng, val.lat);
        let feature = new Feature({
          geometry: new Point(fromLonLat([gd.lng, gd.lat])),
          id: 1,
          type: 'location'
        });
        feature.setStyle(new Style({
          image: new StyleIcon({
            src: this.locationicon,
            anchor: [0.5, 0.5],
            scale: 0.7,
            rotateWithView: true
          })
        }));
        this.locationSource.addFeature(feature);
      }
    },
    /**
     * 路线曲线 选择绘制元素
     */
    addCurveselectInteraction() {
      let that = this;
      this.map.getInteractions().getArray().forEach(interaction => {
        if (interaction instanceof Select) this.map.removeInteraction(interaction);
      });
      this.selectinter = new Select({
        layers: [this.routeLayer],
        condition: click,
        style: feature => {
          let featuretype = feature.getGeometry().getType();
          if (featuretype !== 'LineString' && featuretype !== 'Point' && featuretype !== 'Circle') return;
          return new Style({
            stroke: new StyleStroke({
              lineDash: [3, 6],
              color: 'rgba(0, 0, 255, 1)',
              width: 3
            })
          });
        }
      });
      this.map.addInteraction(this.selectinter);
      this.selectinter.on('select', function (evt) {
        // ////////////////console.log('select');
        // ////////////////console.log(evt);
        // ////////////////console.log(`that.routeData`, that.routeData);
        // ////////////////console.log(`that.selectIndex`, that.selectIndex);
        // ////////////////console.log(`that.routeStyle`, that.routeStyle);

        // 选择后未点击取消或确定按钮 触发事件
        if (that.curvetools !== null && that.curvetools !== undefined && that.selectIndex !== '') {
          that.routeSource.getFeatures().forEach(feature => {
            if (evt.selected.length > 0 && feature.get('id') === evt.selected[0].get('id')) feature.setStyle(new Style({
              stroke: new StyleStroke(that.routeStyle)
            }));
            if (feature.get('id') === that.selectIndex) that.selectinter.getFeatures().push(feature);
          });
          return;
        }
        if (that.selectinter.getFeatures().getArray().length === 0) {
          that.removeCurveModify();
          that.saveCurverouteCoords(false);
        } else {
          // 判断曲线下path 个数 若个数大于2 代表曲线
          that.modifySource = new VectorSource();
          let fIndex = evt.selected[0].get('id');
          if (that.routeData[0].path[fIndex].length > 2) {
            that.selectIndex = fIndex;
            let spath = that.routeData[0].path[fIndex];
            let scurvepath = createBezierCurvePoints(spath.length - 1, spath);
            evt.selected[0].setGeometry(new LineString(spath));
            that.modifySource.addFeature(evt.selected[0]);
            let curveFeature = new Feature({
              id: 999,
              type: 'curve',
              geometry: new LineString(scurvepath)
            });
            curveFeature.setStyle(new Style({
              stroke: new StyleStroke(that.routeStyle)
            }));
            that.routeSource.addFeature(curveFeature);
            let extent = evt.selected[0].getGeometry().getExtent();
            let curvetoolsDom = document.getElementById('curvetools');
            curvetoolsDom.classList.add('show');
            that.curvetools = new Overlay({
              position: [extent[2], extent[3]],
              element: document.getElementById('curvetools')
            });
            that.map.addOverlay(that.curvetools);
          } else {
            that.modifySource.addFeature(that.selectinter.getFeatures().getArray()[0]);
          }
          that.addCurvemodifyInteraction();
          that.saveCurverouteCoords(true);
        }
      });
    },
    /**
     * 路线曲线 修改绘制元素
     */
    addCurvemodifyInteraction() {
      let that = this;
      this.modifyinter = new Modify({
        source: this.modifySource,
        style: this.addStyle()
      });
      this.map.addInteraction(this.modifyinter);
      this.modifyinter.on('modifyend', evt => {
        let select = that.selectinter.getFeatures().getArray();
        select.forEach(feature => {
          that.selectIndex = feature.get('id');
          that.selectCoords = feature.getGeometry().getCoordinates();
          let n = that.selectCoords.length - 1;
          that.selectcurveCoords = createBezierCurvePoints(n, that.selectCoords);
          let extent = feature.getGeometry().getExtent();
          let curvetoolsDom = document.getElementById('curvetools');
          curvetoolsDom.classList.add('show');
          that.curvetools = new Overlay({
            position: [extent[2], extent[3]],
            element: document.getElementById('curvetools')
          });
          that.map.addOverlay(that.curvetools);
          that.routeSource.getFeatures().forEach(item => {
            if (item.get('type') === 'curve') {
              item.setGeometry(new LineString(that.selectcurveCoords));
            } else {
              let curveFeature = new Feature({
                id: 999,
                type: 'curve',
                geometry: new LineString(that.selectcurveCoords)
              });
              curveFeature.setStyle(new Style({
                stroke: new StyleStroke(that.routeStyle)
              }));
              that.routeSource.addFeature(curveFeature);
            }
          });
        });
      });
    },
    /** 移除修改交互 **/
    removeCurveModify() {
      this.modifySource = '';
      this.map.removeInteraction(this.modifyinter);
      this.modifyinter = '';
    },
    /** 曲线重置直线 **/
    resetrouteLine() {
      ////////////////console.log(`this.selectIndex`, this.selectIndex);
      let coords = this.routeData[0].path.filter((item, index) => {
        return index === this.selectIndex;
      });
      let linecoords = [coords[0][0], coords[0][coords[0].length - 1]];
      this.routeData[0].path[this.selectIndex] = linecoords;
      this.resetroutefeature(linecoords);
      this.curverouteCoords[this.selectIndex] = null;
      this.saveCurverouteCoords(false);
      this.resetCurveSelectParams();
    },
    /** 曲线确认操作 **/
    confirmrouteLine() {
      let selectFeature = this.selectinter.getFeatures().getArray()[0];
      let selectFeatureIndex = selectFeature.get('id');
      let selectFeatureCoords = selectFeature.getGeometry().getCoordinates();
      ////////////////console.log(`selectFeatureIndex`, selectFeatureIndex);
      ////////////////console.log(`selectFeatureCoords`, selectFeatureCoords);
      this.routeData[0].path[selectFeatureIndex] = selectFeatureCoords;
      let coords = selectFeatureCoords.slice(1, -1);
      ////////////////console.log(`coords`, coords);
      ////////////////console.log(`this.routeData`, this.routeData);
      this.curverouteCoords[selectFeatureIndex] = coords;
      this.saveCurverouteCoords(false);
      this.resetroutefeature(this.selectcurveCoords);
      this.resetCurveSelectParams();
    },
    /** 路线曲线 重置参数及方法(公共) **/
    resetCurveSelectParams() {
      this.curvetools.setPosition(undefined);
      this.selectinter.getFeatures().clear();
      this.removeCurveModify();
      this.selectCoords = [];
      this.selectIndex = '';
      this.selectcurveCoords = [];
      this.curvetools = null;
    },
    resetroutefeature(coords) {
      this.routeSource.getFeatures().forEach(feature => {
        if (feature.get('id') === this.selectIndex) {
          feature.setGeometry(new LineString(coords));
          feature.setStyle(new Style({
            stroke: new StyleStroke(this.routeStyle)
          }));
        }
        if (feature.get('type') === 'curve') this.routeSource.removeFeature(feature);
      });
    },
    saveCurverouteCoords(flag) {
      //console.log('saveCurverouteCoords')
      //console.log(this.curverouteCoords)
      this.SET_MAPROUTECURVE({
        switch: flag,
        data: this.curverouteCoords.map(item => {
          return item !== null ? item.map(child => {
            return transform(child, 'EPSG:3857', 'EPSG:4326');
          }) : item;
        })
      });
    },
    getmapPixelFromCoordinate(val) {
      ////////////////console.log(`val`, val);
      let iconarr = this.iconSource.getFeatures();
      for (let index = 0; index < iconarr.length; index++) {
        const feature = iconarr[index];
        if (val.id === feature.get('id')) return this.map.getPixelFromCoordinate(feature.getGeometry().getCoordinates());
      }
    }
  }
};